import { Button, Card, Group } from '@mantine/core';
import { IconEye, IconListDetails } from '@tabler/icons-react';
import { useGetModalSectionBorderColor } from 'hooks/useGetModalSectionBorderColor';
import { useState } from 'react';
import { Section, SectionProps } from '../Section';

export const ClaimAdditionalInfoSection = ({
  index,
  title,
  keys,
  cols,
  editComponentsMap,
  type = 'edit',
  initiallyOpened = false,
}: SectionProps & {
  initiallyOpened?: boolean;
}) => {
  const [opened, setOpened] = useState(initiallyOpened);
  const borderColor = useGetModalSectionBorderColor({ keys });

  return (
    <>
      {!opened ? (
        <Group align="center" mt="md" justify="center">
          <Button
            leftSection={<IconEye size={18} />}
            variant="outline"
            onClick={() => setOpened(true)}
            radius="md"
            m="lg"
            color="gray"
          >
            Show Additional Info
          </Button>
        </Group>
      ) : (
        <Card
          padding="md"
          shadow="xs"
          radius="md"
          withBorder
          style={{ borderColor, flexDirection: 'row' }}
          data-testid="claim-detail-section"
          mt="lg"
          display={'flex'}
        >
          <Section
            index={index}
            title={title}
            icon={<IconListDetails size={20} />}
            keys={keys}
            cols={cols}
            grow={true}
            editComponentsMap={editComponentsMap}
            type={type}
            hideLogic={{
              show: opened,
              onToggle: () => setOpened((prev) => !prev),
            }}
          />
        </Card>
      )}
    </>
  );
};
